import { countries, languages } from 'countries-list'

interface Countries {
	[key: string]: {
		capital: string
		continent: string
		currency: string
		emoji: string
		emojiU: string
		languages: string[]
		name: string
		native: string
		phone: string
	}
}

interface Languages {
	[key: string]: {
		name: string
		native: string
	}
}

export interface Country {
	code: string
	name: string
}

export interface Language {
	code: string
	name: string
}

export const getCountries = (): Country[] => {
	const parsedCountries: Language[] = Object.keys(countries).map((code) => {
		return { code, name: (countries as Countries)[code].name }
	})
	return parsedCountries
}

export const getLanguages = (): Language[] => {
	const parsedLanguages = Object.keys(languages)
		.filter((item) => {
			return (languages as Languages)[item].name !== undefined
		})
		.map((code) => {
			return { code, name: (languages as Languages)[code].name }
		})
	return parsedLanguages
}
